import { useState } from "react";
import { Plus } from "lucide-react";
import { JsonLd } from "@/components/JsonLd";
import { faqSchema } from "@/lib/schema";

export type FaqItem = { q: string; a: string };

export function FaqAccordion({
  items,
  idPrefix = "faq",
  withSchema = true,
}: {
  items: FaqItem[];
  idPrefix?: string;
  withSchema?: boolean;
}) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <>
      {withSchema && <JsonLd data={faqSchema(items)} />}
      <div className="rounded-3xl border border-border overflow-hidden divide-y divide-border bg-card/30">
        {items.map((f, i) => {
          const isOpen = open === i;
          const id = `${idPrefix}-${i}`;
          return (
            <div key={f.q} className="bg-background/40">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                aria-controls={`${id}-panel`}
                id={`${id}-trigger`}
                className="w-full flex items-center justify-between gap-6 px-6 py-5 text-left hover:bg-card/60 transition-colors"
              >
                <span className="font-display text-lg md:text-xl leading-snug">{f.q}</span>
                <span
                  className={`shrink-0 grid place-items-center size-9 rounded-full border border-border text-primary transition-transform duration-250 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  <Plus size={16} />
                </span>
              </button>
              <div
                id={`${id}-panel`}
                role="region"
                aria-labelledby={`${id}-trigger`}
                className={`collapsible ${isOpen ? "collapsible-open" : ""}`}
              >
                <div>
                  <p className="px-6 pb-6 -mt-1 text-muted-foreground leading-relaxed max-w-3xl">
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}